<template>
  <section class="richTextExtended container" :class="{'withMoreButton': data.content_short}">
    <div class="richTextExtended__ContentWrapper">
      <div v-if="data.content_short" class="richTextExtended__ShortContent" v-html="data.content_short" />

      <div class="richTextExtended__DefaultContentWrapper" :class="{'isActive': fullTextIsVisible}">
        <div>
          <div class="richTextExtended__DefaultContent" v-html="data.content" />
        </div>
      </div>

      <button v-if="data.content_short && data.content" type="button" @click="toggleTextVisibility" class="richTextExntended__ExpandButton button__Text--Underline">
        <template v-if="!fullTextIsVisible">{{ $t('readMore') }}</template>
        <template v-else>{{ $t('readLess') }}</template>
      </button>
    </div>
  </section>
</template>

<script setup>
  const props = defineProps({ data: {}});
  const fullTextIsVisible = ref(false);

  function toggleTextVisibility() {
    fullTextIsVisible.value = !fullTextIsVisible.value;
  }
</script>

<style lang="scss">
  // @import url('@/assets/styles/components/blocks/_richTextExtended.scss');
</style>